import { toast } from 'sonner';
import { PAID_PLANS_ENABLED } from '@/config/features';
import type { TranslationKeys } from '@/i18n/translations';

/**
 * Free-plan DM limit feedback.
 *
 * V1 ships without paid plans, so the upgrade call-to-action (and any payment
 * reference) is hidden; the user only sees the limit message.
 */
export function notifyDmLimit(t: TranslationKeys, navigate: (path: string) => void) {
  if (!PAID_PLANS_ENABLED) {
    toast.error(t.dm_limit_reached_free);
    return;
  }
  toast.error(t.dm_limit_reached, {
    action: { label: t.upgrade, onClick: () => navigate('/subscription') },
  });
}
